export default {
  toast_messages: {
    google_review_uploaded: 'Tu reseña ha sido verificada. Has ganado {{points}} pts 😉',
  },
};
